import { ColorEnum } from '@/constants/color'
import { useEnabledButtonState } from '@/features/ui/buttons/hooks/useEnabledButtonState'
import { isInteractiveButtonState } from '@/features/ui/buttons/utils'
import Typography from '@/features/ui/typography'
import { hexToRgba } from '@/utils/hexToRgba'
import { FC } from 'react'
import { Pressable, StyleProp, View, ViewStyle } from 'react-native'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

interface MenuItemProps {
    label: string
    divider?: boolean
    onPress: () => void
    disabled?: boolean
    style?: StyleProp<ViewStyle>
}

const MenuItem: FC<MenuItemProps> = ({ label, divider = true, onPress, disabled, style }) => {
    const { state, eventHandlers } = useEnabledButtonState()

    const { styles } = useStyles(stylesheet, {
        disabled,
        state: isInteractiveButtonState(state) ? state : undefined,
    })

    return (
        <Pressable
            {...eventHandlers}
            onPress={onPress}
            disabled={disabled}
            style={[styles.container, style]}
        >
            <Typography.Heading variant="h5" numberOfLines={1} style={styles.text}>
                {label}
            </Typography.Heading>
            {divider && <View style={styles.divider} />}
        </Pressable>
    )
}

const stylesheet = createStyleSheet({
    container: {
        maxWidth: '100%',
        paddingHorizontal: 24,
        variants: {
            state: {
                hovered: {
                    backgroundColor: hexToRgba(ColorEnum.JET_900, 0.0625),
                },
                pressed: {
                    backgroundColor: hexToRgba(ColorEnum.JET_900, 0.25),
                },
            },
        },
    },
    text: {
        justifyContent: 'center',
        lineHeight: 56,
        variants: {
            disabled: {
                true: {
                    color: ColorEnum.GRAY_500,
                },
                false: {
                    color: ColorEnum.GRAY_900,
                },
            },
        },
    },
    divider: {
        borderBottomColor: ColorEnum.GRAY_300,
        borderBottomWidth: 1,
    },
})

export default MenuItem
